export default {
    button_request_permission: 'Permitir',
    default_notification: {
        title: 'Nova Notificação!',
        text: 'Você recebeu uma nova notificação, clique aqui para visualizar',
    },
    notification_permissions: {
        allow: {
            title: 'Permitir Notificações',
            text: `Algumas funcionalidades do sistema usam as notificações do navegador.\nPor favor permita que o sistema possa enviar notificações.`,
        },
        denied: {
            title: 'Notificações Bloqueadas',
            text: 'Identificamos que você negou o acesso às notificações e algumas funcionalidades podem não funcionar.\n'+
                'Por favor, permita que o sistema possa enviar notificações clicando no ícone ao lado esquerdo ou direito da barra de navegação \n' +
                'onde consta o endereço https://app.taskier.io no seu navegador e recarregue a página.',
        },
        noSupport: {
            title: 'Navegador não suportado',
            text: 'Esse navegador não suporta notificações e algumas funcionalidades do sistema podem não funcionar corretamente',
        },
        braveBlocked: {
            title: 'Navegador Brave',
            text: 'Provavelmente o seu navegador está bloqueando receber notificações push.' +
                '\nPara liberar por favor abra uma nova aba, digite o link "brave://settings/privacy" e ative a opção "Use os serviços do Google para receber mensagens push"',
        },
    },
    service_chat: {
        answer: {
            title: 'Solicitação de Chat',
            text: 'O cliente {{name}} está aguardando atendimento no chat',
        },
        accept_transfer: {
            title: 'Solicitação de Transferência de Chat',
            text: 'O usuário {{agent}} está transferindo o chat do cliente {{customer}}',
        },
    },
}
